import React from 'react';

import { clampTokenUsagePercentage } from '~/components/chat/components/token-usage-utils';

import styles from './TokenUsageCircle.module.scss';

const CIRCLE_RADIUS = 6.25;
const CIRCLE_CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;

export interface TokenUsageCircleProps {
  percentage: number;
  ariaLabel: string;
}

export const TokenUsageCircle = ({
  percentage,
  ariaLabel,
}: TokenUsageCircleProps) => {
  const clampedPercentage = clampTokenUsagePercentage(percentage);
  const progressOffset = CIRCLE_CIRCUMFERENCE * (1 - clampedPercentage / 100);

  return (
    <svg
      className={styles.root}
      viewBox="0 0 20 20"
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clampedPercentage}
    >
      <circle className={styles.track} cx="10" cy="10" r={CIRCLE_RADIUS} />
      <circle
        className={styles.progress}
        cx="10"
        cy="10"
        r={CIRCLE_RADIUS}
        strokeDasharray={CIRCLE_CIRCUMFERENCE}
        strokeDashoffset={progressOffset}
        transform="rotate(-90 10 10)"
      />
    </svg>
  );
};
